import { render, staticRenderFns } from "./AMeasureProcessFreeProcessProperties.vue?vue&type=template&id=3769cebe&scoped=true&"
import script from "./AMeasureProcessFreeProcessProperties.vue?vue&type=script&lang=ts&"
export * from "./AMeasureProcessFreeProcessProperties.vue?vue&type=script&lang=ts&"
import style0 from "./AMeasureProcessFreeProcessProperties.vue?vue&type=style&index=0&id=3769cebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3769cebe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
